/*-----------------------------------------------------------------
- landing
-----------------------------------------------------------------*/
export default {
    title: 'Landing',

    subtitle: {
        title: 'To Build Up',
    },
};

